/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tim_OkInputs */

const en_mk_tut_tim_ok = /** @type {(inputs: Mk_Tut_Tim_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Their name appears in the member list, and their avatar becomes選 selectable as an issue assignee.`)
};

const id_mk_tut_tim_ok = /** @type {(inputs: Mk_Tut_Tim_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama orang itu muncul di daftar anggota, dan avatarnya bisa dipilih sebagai penanggung jawab issue.`)
};

/**
* | output |
* | --- |
* | "Their name appears in the member list, and their avatar becomes選 selectable as an issue assignee." |
*
* @param {Mk_Tut_Tim_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tim_ok = /** @type {((inputs?: Mk_Tut_Tim_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tim_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tim_ok(inputs)
	return en_mk_tut_tim_ok(inputs)
});